<p-toast position="top-center"></p-toast>

<p-dialog
    [(visible)]="loading"
    [showHeader]="false"
    [resizable]="false"
    [modal]="true"
    [focusOnShow]="false"
    class="progress-overlay">

    <div class="progress-spinner-container text-center">
        <p-progressSpinner styleClass="comparison-loading-spinner"></p-progressSpinner>
    </div>
</p-dialog>

<div class="row">
    <div class="col-12 tableDateRange">
         <p class="date-range">Date Range: {{date.startDate| date : 'MM/dd/yyyy | HH:mm'}} through {{date.endDate| date : 'MM/dd/yyyy | HH:mm'}}</p>
    </div>
</div>
<div class="row">
    <div class="col-auto pSelectBTN">
        <p-selectButton 
          (onChange)="updateLookbackPeriod($event)" [options]="days" [(ngModel)]="selectedDays" (dateValue)="updatedDate($event)">
        </p-selectButton>
    </div>
</div>

<div class="comparison-layout">
    <div class="comparison-group-grid">
        <p-card header="Group A" class="HeadLiner group-a-card">
            <div class="row">
                <div class="col-md-auto">
                    <div class="label">
                        <label for="float-label">Role Selection</label> 
                    </div>
                    <app-service-grp-select #serviceGroupA [defaultService]="filterA.serviceGroup" (serviceGrpSelected)="onServiceGrpChangedGroup1($event)"></app-service-grp-select>
                </div>
                <!-- <div class="col-md-auto">
                    <div class="label">
                        <label for="float-label">Admin ID Selection</label> 
                     </div>
                     <p-multiSelect [options]="adminOptions" optionValue="value"
                                     (onChange)="changeAdminIDGroup1($event)"
                                     [(ngModel)]="filterA.adminId" 
                                     [filter]="true"
                     ></p-multiSelect>
                </div> -->
            </div>
            <div class="row">
                <div class="col-ml-auto">
                    <div class="label location-label">
                        <label for="float-label">Location Selection</label>
                    </div>
                    <app-location-select #LocationA [user]="authService.user" [isComparisonData]='true' [deId]="deId" (locationSelected)="onLocationChangedGroup1($event)"></app-location-select>
                </div>
            </div>
            <div class="row comparison-statistics">
                <div class="col-auto">
                    <h2>Total Variances</h2>
                    <h3>{{grp1Interaction.totalResolution | number}}</h3>
                </div>
                <div class="col-auto">
                    <h2>High Risk Variances | Rate</h2>
                    <h3>{{grp1Interaction.highRiskCount | number}} | {{grp1DiscrepRate.discrepRate}} %</h3>
                </div>
                <div class="col-auto">
                    <h2>Users</h2>
                    <h3>{{grp1Admin.length | number}}</h3>
                </div>
            </div>
        </p-card>
        <p-card header="Group B" class="HeadLiner group-b-card">
            <div class="row">
                <div class="col-md-auto">
                    <div class="label">
                        <label for="float-label">Role Selection</label> 
                    </div>
                    <app-service-grp-select #serviceGroupB [defaultService]="filterB.serviceGroup" (serviceGrpSelected)="onServiceGrpChangedGroup2($event)"></app-service-grp-select>
                </div>
                <!-- <div class="col-md-auto">
                    <div class="label">
                        <label for="float-label">Admin ID Selection</label> 
                     </div>
                     <p-multiSelect [options]="adminOptions" optionValue="value"
                                    (onChange)="changeAdminIDGroup2($event)"
                                    [(ngModel)]="filterB.adminId" 
                                    [filter]="true"
                    ></p-multiSelect>
                </div> -->
            </div>
            <div class="row">
                <div class="col-ml-auto">
                    <div class="label location-label">
                        <label for="float-label">Location Selection</label>
                    </div>
                    <app-location-select #LocationB [user]="authService.user" [isComparisonData]='true' [deId]="deId" (locationSelected)="onLocationChangedGroup2($event)"></app-location-select>
                </div>
            </div>
            <div class="row comparison-statistics">
                <div class="col-auto">
                    <h2>Total Variances</h2>
                    <h3>{{grp2Interaction.totalResolution | number}}</h3>
                </div>
                <div class="col-auto">
                    <h2>High Risk Variances | Rate</h2>
                    <h3>{{grp2Interaction.highRiskCount | number}} | {{grp2DiscrepRate.discrepRate}} %</h3>
                </div>
                <div class="col-auto">
                    <h2>Users</h2>
                    <h3>{{grp2Admin.length | number}}</h3>
                </div>
            </div>
        </p-card>
    </div>
    <div class="comparison-actions">
        <div class="btnStyle">
            <p-button label="Submit" (click)="submitResults()"></p-button>
            <span pTooltip="Reset" tooltipPosition="bottom" class="refresh-btn">
                <p-button icon="pi pi-refresh" styleClass="p-button-secondary" (click)="onReset()"></p-button> 
            </span> 
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12">
        <p-chart type="line" [data]="comparisonData" [options]="comparisonOptions"></p-chart>
    </div>
</div>
